<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Tabs -->
  <ul class="nav nav-tabs d-flex" id="userMgmtTab" role="tablist">
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link active w-100" id="users-tab" data-bs-toggle="tab" data-bs-target="#usersPane"
        type="button" role="tab" aria-controls="usersPane" aria-selected="true"
        (click)="switchTab('users')">
        Users
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" id="requests-tab" data-bs-toggle="tab" data-bs-target="#requestsPane"
        type="button" role="tab" aria-controls="requestsPane" aria-selected="false"
        (click)="switchTab('requests')">
        User Requests
        <span *ngIf="requestUsers.length > 0" class="badge bg-danger ms-1">{{ requestUsers.length }}</span>
      </button>
    </li>
  </ul>

  <!-- Tab Contents -->
  <div class="tab-content mt-3" id="userMgmtTabContent">

    <!-- ═══ TAB: Users (Approved) ═══ -->
    <div class="tab-pane fade show active" id="usersPane" role="tabpanel" aria-labelledby="users-tab">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="row align-items-center mb-3 mt-3">

            <!-- Search -->
            <div class="col-md-9 col-sm-12 mb-2 mb-md-0">
              <div class="position-relative">
                <input id="searchUser" type="text" class="form-control user-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="searchTextUsers" (input)="performSearchUsers()" />
                <span class="search-icon" (click)="performSearchUsers()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>

            <!-- Add User Button -->
            <div class="col-md-3 col-sm-12 text-md-end text-start" *ngIf="authService.canAdd('userManagement')">
              <button class="btn add-user-btn w-md-auto w-100" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#userFormOffcanvas" aria-controls="userFormOffcanvas" (click)="openAddUserForm()">
                Add User
              </button>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isLoading" class="text-muted">Loading users...</div>
          <div *ngIf="!isLoading && filteredPortalUsers.length === 0" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Approved Portal Users Found.</p>
          </div>

          <!-- Table -->
          <div *ngIf="filteredPortalUsers.length > 0" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">First Name</th>
                  <th class="table-title text-start">Last Name</th>
                  <th class="table-title text-start">Email Address</th>
                  <th class="table-title text-center">Role</th>
                  <th class="table-title text-center">Status</th>
                  <th class="table-title text-center"><i class="bi bi-eye"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of pagedPortalUsers">
                  <td class="table-data-text text-start">{{ user.firstName }}</td>
                  <td class="table-data-text text-start">{{ user.lastName }}</td>
                  <td class="table-data-text text-start">{{ user.email }}</td>
                  <td class="table-data-text text-center">{{ getRoleName(user.corporateRoleKey) }}</td>
                  <td class="table-data-text text-center">
                    <span class="status-badge" [ngClass]="user.isActive ? 'badge-active' : 'badge-inactive'">
                      <i class="bi" [ngClass]="user.isActive ? 'bi-check-circle-fill' : 'bi-x-circle-fill'"></i>
                      {{ user.isActive ? 'Active' : 'Disabled' }}
                    </span>
                  </td>
                  <td class="table-data-text text-center">
                    <button class="btn p-0" style="background: none; border: none;" data-bs-toggle="offcanvas"
                      data-bs-target="#userFormOffcanvas" aria-controls="userFormOffcanvas"
                      (click)="openViewUserForm(user)">
                      <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <app-paginator [dataSource]="filteredPortalUsers" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onPortalUserPageChange($event)">
            </app-paginator>
          </div>

        </div>
      </div>
    </div>

    <!-- ═══ TAB: User Requests (Pending / Rejected) ═══ -->
    <div class="tab-pane fade" id="requestsPane" role="tabpanel" aria-labelledby="requests-tab">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="row align-items-center mb-3 mt-3">

            <!-- Search -->
            <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
              <div class="position-relative">
                <input type="text" class="form-control user-search-input shadow-none"
                  placeholder="Search requests..." [(ngModel)]="searchTextRequests" (input)="performSearchRequests()" />
                <span class="search-icon" (click)="performSearchRequests()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isLoadingRequests" class="text-muted">Loading requests...</div>
          <div *ngIf="!isLoadingRequests && filteredRequestUsers.length === 0" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Pending User Requests.</p>
          </div>

          <!-- Table -->
          <div *ngIf="filteredRequestUsers.length > 0" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">First Name</th>
                  <th class="table-title text-start">Last Name</th>
                  <th class="table-title text-start">Email Address</th>
                  <th class="table-title text-center">Role</th>
                  <th class="table-title text-center">Submitted</th>
                  <th class="table-title text-center">Status</th>
                  <th class="table-title text-center"><i class="bi bi-eye"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let req of pagedRequestUsers">
                  <td class="table-data-text text-start">{{ req.firstName }}</td>
                  <td class="table-data-text text-start">{{ req.lastName }}</td>
                  <td class="table-data-text text-start">{{ req.email }}</td>
                  <td class="table-data-text text-center">{{ getRoleName(req.corporateRoleKey) }}</td>
                  <td class="table-data-text text-center">{{ req.createdDate | date:'dd MMM yyyy' }}</td>
                  <td class="table-data-text text-center">
                    <span class="status-badge" [ngClass]="getApprovalStatusClass(req.approvalStatus)">
                      <i class="bi me-1" [ngClass]="getApprovalStatusIcon(req.approvalStatus)"></i>
                      {{ req.approvalStatus }}
                    </span>
                  </td>
                  <td class="table-data-text text-center">
                    <button class="btn p-0" style="background: none; border: none;" data-bs-toggle="offcanvas"
                      data-bs-target="#userFormOffcanvas" aria-controls="userFormOffcanvas"
                      (click)="openViewRequestForm(req)">
                      <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <app-paginator [dataSource]="filteredRequestUsers" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onRequestPageChange($event)">
            </app-paginator>
          </div>

        </div>
      </div>
    </div>

  </div>

</div>

<!-- User Form Offcanvas -->
<div #userFormOffcanvasEl class="offcanvas offcanvas-end w-80" tabindex="-1" id="userFormOffcanvas"
  aria-labelledby="userFormOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">

  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">

        <!-- Title with Icon -->
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="userFormOffcanvasLabel">
            <i class="bi fs-5" [ngClass]="{
              'bi-person-plus': mode === 'add',
              'bi-person': mode === 'view',
              'bi-person-lines-fill': mode === 'edit'
            }"></i>
            {{ mode === 'add' ? 'Add New User' : mode === 'view' ? 'User Details' : 'Edit User' }}
          </h5>
        </div>

        <!-- Close Button -->
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></span>
        </div>

      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <form [formGroup]="userForm">
      <!-- Row 1: First Name | Last Name -->
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 form-group-fixed">
            <label class="label-text">First Name <span class="text-danger">*</span></label>
            <input type="text" appInputLimit formControlName="firstName" class="form-control rounded-pill shadow-none input-pill"
              placeholder="Type here"
              [class.is-invalid]="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched" />
            <div class="invalid-feedback">
              <div *ngIf="userForm.get('firstName')?.errors?.['required']">First name is required.</div>
              <div *ngIf="userForm.get('firstName')?.errors?.['pattern']">Please enter a valid first name.</div>
              <div *ngIf="userForm.get('firstName')?.errors?.['maxlength']">
                First name cannot exceed {{ userForm.get('firstName')?.errors?.['maxlength'].requiredLength }}
                characters.
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3 form-group-fixed">
            <label class="label-text">Last Name <span class="text-danger">*</span></label>
            <input type="text" appInputLimit formControlName="lastName" class="form-control rounded-pill shadow-none input-pill"
              placeholder="Type here"
              [class.is-invalid]="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched" />
            <div class="invalid-feedback">
              <div *ngIf="userForm.get('lastName')?.errors?.['required']">Last name is required.</div>
              <div *ngIf="userForm.get('lastName')?.errors?.['pattern']">Please enter a valid last name.</div>
              <div *ngIf="userForm.get('lastName')?.errors?.['maxlength']">
                Last name cannot exceed {{ userForm.get('lastName')?.errors?.['maxlength'].requiredLength }} characters.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2: Mobile | Email -->
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 form-group-fixed">
            <label class="label-text">Mobile Number <span class="text-danger">*</span></label>
            <input type="tel" appInputLimit pattern="[0-9+]*" inputmode="numeric" maxlength="12" formControlName="mobileNumber"
              class="form-control rounded-pill shadow-none input-pill" placeholder="Type here"
              [class.is-invalid]="userForm.get('mobileNumber')?.invalid && userForm.get('mobileNumber')?.touched" />
            <div class="invalid-feedback">
              <div *ngIf="userForm.get('mobileNumber')?.errors?.['required']">Mobile number is required.</div>
              <div *ngIf="userForm.get('mobileNumber')?.errors?.['pattern']">Please enter a valid mobile number.</div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3 form-group-fixed">
            <label class="form-label">Email Address <span class="text-danger">*</span></label>
            <input type="email" appInputLimit class="form-control rounded-pill" placeholder="Type here"
              [class.is-invalid]="userForm.get('email')?.invalid && userForm.get('email')?.touched"
              formControlName="email" />
            <div class="invalid-feedback">
              <div *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</div>
              <div *ngIf="userForm.get('email')?.errors?.['pattern'] || userForm.get('email')?.errors?.['email']">
                Please enter a valid email address.
              </div>
              <div *ngIf="userForm.get('email')?.errors?.['maxlength']">
                Email cannot exceed {{ userForm.get('email')?.errors?.['maxlength'].requiredLength }} characters.
              </div>
            </div>
          </div>
        </div>
      </div>

      <h6 class="text-muted mt-5">Access Permissions</h6>
      <hr class="mb-4" />

      <div class="d-flex align-items-center mb-3">
        <label class="me-2 mb-0">Access Role</label>
        <div class="position-relative d-inline-block">
          <select class="form-select form-select-sm rounded-pill shadow-none w-auto custom-select-arrow"
            [(ngModel)]="selectedCorporateRole" (change)="onCorporateRoleChange(selectedCorporateRole)"
            [disabled]="isRoleDropdownDisabled()" [ngModelOptions]="{ standalone: true }">
            <option *ngFor="let role of corporateRolesList" [value]="role.value">
              {{ role.name }}
            </option>
          </select>
          <i class="dropdown-icon bi bi-chevron-down"></i>
        </div>
      </div>

      <hr class="mb-4" />

      <div class="table-responsive">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th style="min-width:220px;">Module / Menu</th>
              <th class="text-center">View</th>
              <th class="text-center">Edit</th>
              <th class="text-center">Add</th>
              <th class="text-center">Review</th>
              <th class="text-center">Level</th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let group of navModules">
              <!-- Parent header row (only when there are children) -->
              <tr class="bg-light" *ngIf="((group.children?.length ?? 0) > 0)">
                <td class="fw-semibold">{{ group.title }}</td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center"></td>
              </tr>

              <!-- Child rows (checkboxes + optional level) -->
              <tr *ngFor="let item of (group.children ?? [])">
                <td class="ps-4">{{ item.title }}</td>

                <!-- View -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[item.key].view"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(item.key)"
                    [disabled]="isAccessDisabled(item.key)" />
                </td>

                <!-- Edit -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[item.key].edit"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(item.key)"
                    [disabled]="isAccessDisabled(item.key)" />
                </td>

                <!-- Add -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[item.key].add"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(item.key)"
                    [disabled]="isAccessDisabled(item.key)" />
                </td>

                <!-- Review -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[item.key].review"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(item.key)"
                    [disabled]="isAccessDisabled(item.key)" />
                </td>

                <!-- Level (optional per child) -->
                <td class="text-center">
                  <ng-container *ngIf="item.showLevel; else noLevelChild">
                    <div class="position-relative d-inline-block">
                      <select class="form-select form-select-sm rounded-pill shadow-none w-auto custom-select-arrow"
                        [(ngModel)]="accessMatrix[item.key].level" [ngModelOptions]="{ standalone: true }"
                        (change)="onAccessLevelChange(item.key)" [disabled]="isAccessDisabled(item.key)">
                        <option *ngFor="let lvl of authorityLevelsList" [value]="lvl.value"
                          [disabled]="lvl.value === 'custom'">
                          {{ lvl.name.replace('Level ', 'L') }}
                        </option>
                      </select>
                      <i class="dropdown-icon bi bi-chevron-down"></i>
                    </div>
                  </ng-container>
                  <ng-template #noLevelChild>
                    <span class="text-muted">—</span>
                  </ng-template>
                </td>
              </tr>

              <!-- Leaf row (no children => render this module itself) -->
              <tr *ngIf="(group.children?.length ?? 0) === 0">
                <td class="ps-1 fw-semibold">{{ group.title }}</td>

                <!-- View -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[group.key].view"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(group.key)"
                    [disabled]="isAccessDisabled(group.key)" />
                </td>

                <!-- Edit -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[group.key].edit"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(group.key)"
                    [disabled]="isAccessDisabled(group.key)" />
                </td>

                <!-- Add -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[group.key].add"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(group.key)"
                    [disabled]="isAccessDisabled(group.key)" />
                </td>

                <!-- Review -->
                <td class="text-center">
                  <input type="checkbox" class="custom-checkbox" [(ngModel)]="accessMatrix[group.key].review"
                    [ngModelOptions]="{ standalone: true }" (change)="onAccessCheckboxChange(group.key)"
                    [disabled]="isAccessDisabled(group.key)" />
                </td>

                <!-- Level (optional per leaf) -->
                <td class="text-center">
                  <ng-container *ngIf="group.showLevel; else noLevelLeaf">
                    <div class="position-relative d-inline-block">
                      <select class="form-select form-select-sm rounded-pill shadow-none w-auto custom-select-arrow"
                        [(ngModel)]="accessMatrix[group.key].level" [ngModelOptions]="{ standalone: true }"
                        (change)="onAccessLevelChange(group.key)" [disabled]="isAccessDisabled(group.key)">
                        <option *ngFor="let lvl of authorityLevelsList" [value]="lvl.value"
                          [disabled]="lvl.value === 'custom'">
                          {{ lvl.name.replace('Level ', 'L') }}
                        </option>
                      </select>
                      <i class="dropdown-icon bi bi-chevron-down"></i>
                    </div>
                  </ng-container>
                  <ng-template #noLevelLeaf>
                    <span class="text-muted">—</span>
                  </ng-template>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <hr>

      <!-- Buttons -->
      <div class="d-flex justify-content-between align-items-center gap-2 mt-3 flex-wrap">
      
        <!-- Status toggle: only for approved Users tab -->
        <div *ngIf="mode !== 'add' && selectedUser && activeTab === 'users'" class="d-flex align-items-center gap-2">
          <span class="label-text mb-0">Account Status:</span>
          <span class="status-badge" [ngClass]="selectedUser.isActive ? 'badge-active' : 'badge-inactive'">
            <i class="bi" [ngClass]="selectedUser.isActive ? 'bi-check-circle-fill' : 'bi-x-circle-fill'"></i>
            {{ selectedUser.isActive ? 'Active' : 'Disabled' }}
          </span>
          <button *ngIf="authService.canEdit('userManagement')" type="button" class="btn btn-sm toggle-status-btn"
            [ngClass]="selectedUser.isActive ? 'btn-disable' : 'btn-enable'" [disabled]="isTogglingStatus || disableSelfDisable"
            (click)="toggleUserStatus()">
            <span *ngIf="isTogglingStatus" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!isTogglingStatus" class="bi me-1"
              [ngClass]="selectedUser.isActive ? 'bi-slash-circle' : 'bi-check-circle'"></i>
            {{ isTogglingStatus ? 'Please wait...' : (selectedUser.isActive ? 'Disable User' : 'Enable User') }}
          </button>
        </div>

        <!-- Request status badge: shown when viewing a request -->
        <div *ngIf="activeTab === 'requests' && selectedRequestUser" class="d-flex align-items-center gap-2">
          <span class="label-text mb-0">Request Status:</span>
          <span class="status-badge" [ngClass]="getApprovalStatusClass(selectedRequestUser.approvalStatus)">
            <i class="bi me-1" [ngClass]="getApprovalStatusIcon(selectedRequestUser.approvalStatus)"></i>
            {{ selectedRequestUser.approvalStatus }}
          </span>
        </div>
      
        <!-- Spacer when in add mode -->
        <div *ngIf="mode === 'add'"></div>
      
        <!-- Right side action buttons -->
        <div class="d-flex gap-2">

          <!-- Add Mode Buttons -->
          <ng-container *ngIf="mode === 'add' && authService.canAdd('userManagement')">
            <button type="button" class="btn btn-outline-secondary" (click)="clearForm()">
              <i class="bi bi-x-circle me-2"></i> Clear
            </button>
            <button type="button" class="btn btn-success" [disabled]="!userForm.valid" (click)="submitForm()">
              <i class="bi bi-plus-circle me-2"></i> Submit
            </button>
          </ng-container>
      
          <!-- View Mode Button: only for Users tab -->
          <button *ngIf="mode === 'view' && activeTab === 'users' && authService.canEdit('userManagement')"
            type="button" class="btn btn-warning" (click)="enterEditMode()">
            <i class="bi bi-pencil-square me-2"></i> Edit
          </button>
      
          <!-- Edit Mode Buttons: only for Users tab -->
          <ng-container *ngIf="mode === 'edit' && activeTab === 'users' && authService.canEdit('userManagement')">
            <button type="button" class="btn btn-outline-secondary" (click)="cancelEdit()">
              <i class="bi bi-x-circle me-2"></i> Cancel
            </button>
            <button type="button" class="btn btn-success" (click)="saveChanges()">
              <i class="bi bi-save me-2"></i> Save Changes
            </button>
          </ng-container>

          <!-- Approve / Reject Buttons: only for Super Admin viewing a Pending request -->
          <ng-container *ngIf="activeTab === 'requests' && isSuperAdmin() && selectedRequestUser?.approvalStatus === 'Pending'">
            <button type="button" class="btn btn-outline-danger btn-sm review-btn"
              [disabled]="isRejecting || isApproving" (click)="rejectRequest(selectedRequestUser)">
              <span *ngIf="isRejecting" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!isRejecting" class="bi bi-x-circle me-1"></i>
              Reject
            </button>
            <button type="button" class="btn btn-approve btn-sm review-btn"
              [disabled]="isApproving || isRejecting" (click)="approveRequest(selectedRequestUser)">
              <span *ngIf="isApproving" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!isApproving" class="bi bi-check-circle me-1"></i>
              Approve
            </button>
          </ng-container>

        </div>
      
      </div>

    </form>
  </div>
</div>